import Vue from 'vue'
import axios from 'axios'

const api = axios.create({
    baseURL: 'https://howardlee.cn/api',
    // baseURL: 'http://localhost:5000',
    withCredentials: true
})

Vue.prototype.$http = api

async function getTables(db) {
    return api.get('tables/' + db)
}

async function login(email, institute, ipaddress) {
    return api.post('login', {
        email: email,
        institute: institute,
        ipaddress: ipaddress
    })
}

async function ask(question) {
    return api.post('qa', {
        question: question
    })
}

async function askNoNLP(question) {
    return api.post('qa', question, {
        params: {
            nonlp: "yes"
        }
    })
}

async function feedback(recordId, feedback) {
    return api.post('feedback', {
        id: recordId,
        feedback: feedback
    })
}

async function getPlan(sql, db, email) {
    return api.post('sql/' + db, {
        sql: sql,
        email: email
    })
}

export {
    getTables,
    login,
    ask,
    askNoNLP,
    feedback,
    getPlan
}
